<template>
    <input class="btn" type="submit" :value="translations.save">
</template>

<script>
export default {
  name: 'app-content-save-button',
  computed: {
    translations() {
      return {
        save: this.$gettext('Uložit')
      }
    }
  }
}
</script>
